import one360 from './one360';
import type { AbschlussberichtDraft, AbschlussberichtSubmission, AbschlussberichtTemplate } from '../../types/abschlussbericht';

export const getAbschlussberichtTemplate = async (
  projectId: string
): Promise<AbschlussberichtTemplate> =>
  one360.get<AbschlussberichtTemplate>(`/api/v1/ops/projects/${encodeURIComponent(projectId)}/abschlussbericht-template`, {
    timeout: 90000,
  });

export const submitAbschlussbericht = async (
  projectId: string,
  payload: AbschlussberichtSubmission
): Promise<void> =>
  one360.post(`/api/v1/ops/projects/${encodeURIComponent(projectId)}/abschlussbericht-submissions`, payload);

export const upsertAbschlussberichtDraft = async (
  projectId: string,
  payload: AbschlussberichtDraft
): Promise<void> =>
  one360.put(`/api/v1/ops/projects/${encodeURIComponent(projectId)}/abschlussbericht-draft`, payload);
